import React from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { FormattedHTMLMessage } from 'react-intl';

import Paper from 'components/Paper';
import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';

import { formatHeaderDate } from 'lib/dateDisplay';

import CommonHeader from 'routes/Documents/components/CommonHeader';
import { path } from 'ramda';
import ActionButton from 'components/ActionButton';
import { withSession } from 'containers/SessionProvider';
import { colors } from 'styles/provider';
import Rehabilitations from './Rehabilitations';
import { getAllCommitsData } from 'lib/documentHandling';

const fm = (id, values) => <FormattedHTMLMessage id={id} values={values} />;

const DocumentRow = ({ d, setViewing }) => {
  const data = getAllCommitsData(d);

  const rehabsProgression = ['rehab1', 'rehab2', 'rehab3', 'rehab4', 'rehab5', 'rehab6', 'rehab7']
    .map(r => path([r, 'finished'], data))
    .filter(f => f).length;

  const commentsFatigue = path(['rehab3', 'neurologistsComments'], data);
  const commentsCognition = path(['rehab5', 'neurologistsComments'], data);
  const commentsLength = [commentsFatigue, commentsCognition].filter(c => c).length;
  return (
    <HistoryEntry>
      <HistoryEntryHeader title={data.start ? formatHeaderDate(data.start) : fm('npView.history.notStarted')} active>
        <Row end="xs">
          <Col>
            <ActionButton localeId="npView.history.open" onClick={() => setViewing(d.documentId)} border secondary />
          </Col>
        </Row>
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={fm('npView.history.status')}>
          <p>{data.start ? fm('npView.history.started') : data.cancelled ? fm('npView.history.cancelled') : '-'}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={fm('npView.history.progression')}>
          <p>{rehabsProgression} / 7</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={fm('npView.history.feedbackGiven')}>
          <p>{`${commentsLength}`} / 2</p>
        </HistoryEntryColumn>
      </HistoryEntryColumns>
    </HistoryEntry>
  );
};

DocumentRow.propTypes = {
  d: PropTypes.object,
  setViewing: PropTypes.func,
};

const NPView = ({ names, documents, session }) => {
  const [viewing, setViewing] = React.useState(null);

  const onlineRehabDocs = documents.filter(d => d.documentType === 'onlineRehabilitation') || [];

  return (
    <div>
      <Paper topMargin={false}>
        <Grid fluid>
          <CommonHeader
            names={names}
            infoElement={
              <p className="bold" style={{ color: colors.clrText, fontSize: '1.4rem', marginTop: '1rem' }}>
                {fm('npView.infotext', {
                  name: `${session.firstName} ${session.lastName}`,
                  ssn: session.citizenId,
                })}
              </p>
            }
            localeId="npView.title"
            mode="create"
            editing={{ editing: true }}
            startEdit={() => ''}
          />
        </Grid>
        {!viewing && onlineRehabDocs.map(d => <DocumentRow key={d.documentId} d={d} setViewing={setViewing} />)}
        {viewing && (
          <Rehabilitations
            document={onlineRehabDocs.find(d => d.documentId === viewing)}
            fm={fm}
            closeView={() => setViewing(null)}
            allDocuments={documents}
          />
        )}
      </Paper>
    </div>
  );
};

NPView.propTypes = {
  names: PropTypes.array,
  documents: PropTypes.array,
  session: PropTypes.object,
};

export default withSession(NPView);
